import React from "react";
import img1 from "../../Image/Rectangle 34625569.png";
import "../Home.css";
import { Link } from "react-router-dom";

function Exp() {
  return (
    <div>
      <div className="container-fluid home-banner-div1">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div>
                <img src={img1} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-7 home-banner-col2-div1">
              <div className="home-banner-col2-text11">
                <h1>Interested in layered waxing?</h1>
                <h4>Select one option</h4>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="home-banner-btn1">
                      <Link to="/expert2">
                        <div className="btn1">Yes</div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="home-banner-btn1">
                      <Link to="/expert1">
                        <div className="btn1">No</div>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="next-btn-div1">
                  <Link to="/">
                    <div className="next-btn1">
                      <svg
                        class="mr-3"
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="16"
                        viewBox="0 0 11 16"
                        fill="none"
                      >
                        <path
                          d="M9 14L3 8L9 2"
                          stroke="rgba(0, 0, 0, 0.80)"
                          stroke-width="4"
                          stroke-linecap="round"
                        />
                      </svg>{" "}
                      Back
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Exp;
